(() => {
  const menuButton = document.querySelector("[data-menu-toggle]");
  const mobileNav = document.querySelector("[data-mobile-nav]");

  if (menuButton && mobileNav) {
    menuButton.addEventListener("click", () => {
      const isOpen = menuButton.getAttribute("aria-expanded") === "true";
      menuButton.setAttribute("aria-expanded", String(!isOpen));
      menuButton.setAttribute("aria-label", isOpen ? "Open menu" : "Close menu");
      mobileNav.hidden = isOpen;
    });

    mobileNav.addEventListener("click", (event) => {
      if (event.target instanceof HTMLAnchorElement) {
        mobileNav.hidden = true;
        menuButton.setAttribute("aria-expanded", "false");
        menuButton.setAttribute("aria-label", "Open menu");
      }
    });
  }

  document.querySelectorAll("[data-sort-select]").forEach((select) => {
    select.addEventListener("change", () => {
      if (select.form) select.form.submit();
    });
  });

  document.querySelectorAll(".product-form").forEach((form) => {
    const variantSelect = form.querySelector("[data-variant-select]");
    const price = form.closest(".product-detail")?.querySelector("[data-variant-price]");
    const comparePrice = form.closest(".product-detail")?.querySelector("[data-variant-compare]");
    const addButton = form.querySelector("[data-add-button]");

    if (!(variantSelect instanceof HTMLSelectElement)) return;

    const updateVariant = () => {
      const option = variantSelect.selectedOptions[0];
      if (!option) return;
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (comparePrice) {
        const compare = option.dataset.comparePrice || "";
        comparePrice.textContent = compare;
        comparePrice.hidden = !compare;
      }
      if (addButton) {
        const available = option.dataset.available === "true";
        addButton.disabled = !available;
        addButton.textContent = available ? "ADD TO BAG" : "SOLD OUT";
      }
    };

    variantSelect.addEventListener("change", updateVariant);
  });
})();
